<div [id]="htmlId()" class="section" [style.display]="isVisible() ? 'block' : 'none'">
  <button
    type="button"
    role="button"
    class="new-iteration-opener"
    (click)="onRequestNewInstance()"
    [disabled]="isReadonly() || form().disabled">
    <div class="icon">
      <mat-icon>repeat</mat-icon>
    </div>
    {{ translateService.instant('liveforms-editor.repeater-item.add-button') }}
  </button>
</div>
